import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=8dfd6be4&scoped=true&"
import script from "./TypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TypeSelect.vue?vue&type=style&index=0&id=8dfd6be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfd6be4",
  null
  
)

export default component.exports